// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"eede0a93","218":"ad935a4c","355":"b02b1f5c","712":"4c75376e","807":"785a3fb0"}[chunkId] + ".chunk.js";
};